export default {
  data() {
    return {}
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    galaxyUserID() {
      return this.$store.getters['galaxy/user']
    }
  },
  methods: {
    pushMetaEvent(isLangSwitchOrLogin) {
      function gtag() {
        dataLayer.push(arguments)
      }
      gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
        wait_for_update: 2000
      })
      if (this.language) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'page_meta',
          user_id: this.galaxyUserID ? this.galaxyUserID : null,
          language: this.language.toLowerCase(),
          environment: window.location.href.includes('www.digitl')
            ? 'production'
            : 'staging'
        })
        if (isLangSwitchOrLogin) {
          setTimeout(() => {
            this.pushPageViewEvent({})
          }, 300)
        }
      }
    },
    pushErrorEvent() {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'digitl_event',
        event_name: `${this.error.statusCode}_error`
      })
    },
    // addGTM() {
    // window.dataLayer = window.dataLayer || []
    // function gtag() {
    //   dataLayer.push(arguments)
    // }
    // gtag('consent', 'default', {
    //   ad_storage: 'denied',
    //   analytics_storage: 'denied'
    // })
    // ;(function (w, d, s, l, i) {
    //   w[l] = w[l] || []
    //   w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    //   var f = d.getElementsByTagName(s)[0],
    //     j = d.createElement(s),
    //     dl = l != 'dataLayer' ? '&l=' + l : ''
    //   j.async = true
    //   j.src = 'https://ssgtm.digitl.net/gtm.js?id=' + i + dl
    //   f.parentNode.insertBefore(j, f)
    // })(window, document, 'script', 'dataLayer', 'GTM-M6CKLTL')
    // },
    pushPageViewEvent(obj) {
      window.dataLayer = window.dataLayer || []
      let dataLayerObject = {
        event: 'virtual_page_view',
        page_path: window.location.href,
        page_title: document.title,
        virtual_page_view: {
          content_type: obj.content_type
        }
      }
      if (Object.keys(obj).includes('content_type')) {
        dataLayerObject.content_type = obj.content_type
      }

      let intervaller = setInterval(() => {
        if (
          window.dataLayer.filter((item) => item.event == 'page_meta').length
        ) {
          clearInterval(intervaller)
          window.dataLayer.push(dataLayerObject)
        }
      }, 50)
    },
    pushEvent({ eventName, eventDetails }) {
      if (eventName) {
        let dataLayerObject = {
          event: 'digitl_event',
          event_name: eventName
        }
        if (eventDetails) {
          dataLayerObject[eventName] = eventDetails
        }
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(dataLayerObject)
      }
    }
  },
  mounted() {}
}
